import { httpRequest } from '@calendly/http-tools'

export const listGroups = (params = {}) => httpRequest({
  url: '/api/organization/user_groups',
  method: 'GET',
  params
})

export const getGroup = (groupId) => httpRequest({
  url: `/api/organization/user_groups/${groupId}`,
  method: 'GET'
})

export const createGroup = (userGroup) => httpRequest({
  url: '/api/organization/user_groups',
  method: 'POST',
  data: userGroup
})

export const updateGroup = (groupId, params) => httpRequest({
  url: `/api/organization/user_groups/${groupId}`,
  method: 'PUT',
  data: params
})

export const destroyGroup = (groupId) => httpRequest({
  url: `/api/organization/user_groups/${groupId}`,
  method: 'DELETE'
})

export const getUserMemberships = (groupId, { page, filter, sortField, sortOrder } = { page: 1 }) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: { page, user_group_id: groupId, filter_term: filter, sort_field: sortField, sort_order: sortOrder }
})

export const getInvitationMemberships = (groupId, { page, filter, sortField, sortOrder, status } = { page: 1 }) => httpRequest({
  url: '/api/organization/invitations',
  method: 'GET',
  params: { page, user_group_id: groupId, filter_term: filter, sort_field: sortField, sort_order: sortOrder, status }
})

export const removeRelationships = (groupId, relationshipIds) => httpRequest({
  url: `/api/organization/user_groups/${groupId}/relationships/batch_delete`,
  method: 'DELETE',
  data: {
    ids: relationshipIds
  }
})

export const createUserGroupRelationships = (groupId, data) => httpRequest({
  url: `/api/organization/user_groups/${groupId}/relationships`,
  method: 'POST',
  data
})

export const resendInvitation = (invitationId) => httpRequest({
  url: `/api/organization/invitations/${invitationId}/resend`,
  method: 'POST'
})
